import React, { useEffect, useState, useRef } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Switch,
  styled,
  Stack,
  Button,
  Modal,
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField as MUITextField,
  Fade,
  CircularProgress,
} from "@mui/material";
import { Image, Form as RBFORM } from 'react-bootstrap';
import { FieldArray, Form, Field, ErrorMessage } from 'formik';
import { CheckboxWithLabel, TextField, } from 'formik-material-ui';

import Grid from "@mui/material/Grid2";
import disableIcon from "../../../assets/images/icon/disableIcon.svg"
import { getMethod, postMethod, putMethod } from '../../../services/apiService';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { getUserId } from '../../../helper/helper';
import { Formik } from 'formik';
import { clearStorageAndCookies, getPartnetId } from '../../../services/authService';
import { ToastContext, useToastContext } from '../../../context/toastContext';
import * as Yup from "yup";
import CloseIcon from '@mui/icons-material/Close';
import deleteIcon from "../../../assets/images/icon/delete-icon.svg";
import { ToastContainer } from "react-toastify";
import closeIcon from "../../../assets/images/close.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {LICENSE_VALIDITY_RANGES} from '../../../constants/constants';
import { PROFILE_TYPE } from '../../../helper/globalConstant';
import { usePartnerIdContext } from '../../../context/partnerIdContext';

const styleModal = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "420px",
  backgroundColor: "#1D292E",
  borderRadius: "8px",
  padding: "24px",
  boxShadow: "2px 2px 20px 2px #FFFFFF14"
};

interface LicenseDetails {
  featureKey: string;
  licenseKey: string;
  quantity: number;
  license: any;
  validity: number;
  createdAt: number; // Unix timestamp in milliseconds
  activationOn: number; // Unix timestamp in milliseconds
  expiry: number; // Unix timestamp in milliseconds
  status: number; // Enum or specific meaning for different statuses
}
const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 40, // Slightly smaller width for the switch
  height: 24, // Slightly smaller height for the switch
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: "14px", // Slightly smaller thumb size
      height: "14px", // Slightly smaller thumb size
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 4, // Adjusted padding for a smaller thumb
    "&.Mui-checked": {
      transform: "translateX(16px)", // Adjusted translation for smaller switch
      color: "#1F2F34",
      "& .MuiSwitch-thumb": {
        backgroundColor: "#1E2121", // Make the thumb black when enabled
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#17B2EB",
        border: "1.5px solid #17B2EB", // Thicker border on active state
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: "14px", // Slightly smaller thumb size
    height: "14px", // Slightly smaller thumb size
    margin: "1px", // Adjusted margin to center the thumb
    borderRadius: "50%", // Ensuring the thumb remains perfectly round
    boxShadow: "none",
    transition: theme.transitions.create(["width"], {
      duration: 300,
    }),
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "transparent",
    boxSizing: "border-box",
    border: "1.5px solid var(--text-text-tertiary, #A5A8A9)",
    borderRadius: 24 / 2, // Adjusted border radius for the smaller track
  },
}));


function OrderDetailTabThree() {


  const { setToast } = useToastContext() as ToastContext;
  const navigate = useNavigate();
  const inputRef = useRef<HTMLInputElement | null>(null); 
  
  const location = useLocation();
  const { order, siteOrderId } = location.state || {};
  // const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  // const [licenseDetails, setLicenseDetails] = useState<LicenseDetails[] | null>(null);
  const [licenseDetails, setLicenseDetails] = useState<any[]>([]);
  const [featureList, setFeatureList] = useState([]);
  const [filteredFeatureList, setFilteredFeatureList] = useState([]);
  const [validity, setValidity] = useState(30);
  const [siteId, setSiteId] = useState<number | undefined>(undefined);
  // const [partnerId, setPartnerId] = useState("");
  const [availableFeature, setAvailableFeature] = useState(0);
  const [featureModalOpen, setFeatureModalOpen] = useState(false);
  const datepickerRef = useRef<HTMLDivElement | null>(null);
  const endDatepickerRef = useRef<HTMLDivElement | null>(null);
  const [loader, showLoader] = useState(true);
  const { partnerId, setPartnerId } = usePartnerIdContext();

  const [displayDatePicker, setDisplayDatePicker] = useState(false);
  const [startDate, setStartDate] = useState<any>("");
  const [startMin, setStartMin] = useState<any>("")
  const [startMax, setStartMax] = useState<any>("")


  const [displayEndDatePicker, setDisplayEndDatePicker] = useState<boolean>(false);
  const [endDate, setEndDate] = useState<any>("")
  const [endMin, setEndMin] = useState<any>("")
  const [endMax, setEndMax] = useState<any>("")

  useEffect(() => {
    setValidity(30);
  }, [featureModalOpen]);


  const getDate = (days: number, input?: Date) => {
    const date = input ? new Date(input) : new Date();
    date.setDate(date.getDate() + days);
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };


  const [initialValues, setInitialValues] = useState({
    orderRef: '',
    siteId: siteId,
    partnerId: partnerId,
    licenseKey: '',
    validity: validity,
    start_date: getDate(0),
    end_date: getDate(1),
    quantity: 0,
  });


  const handleCheckboxChange = (row: any) => {
    setSelectedRows((prev: any) => {
      const isAlreadySelected = prev.some(
        (selectedRow: any) => selectedRow?.featureKey === row?.siteOrder?.data?.[0]?.featureKey
      );

      if (isAlreadySelected) {
        // Remove the row if it is already selected
        return prev.filter(
          (selectedRow: any) => selectedRow?.featureKey !== row?.siteOrder?.data?.[0]?.featureKey
        );
      } else {
        const obj = {
          "featureKey": row?.siteOrder?.data?.[0]?.featureKey,
          "status": 0,
          "expiry": row?.siteOrder?.data?.[0]?.expiry
        }
        // Clone the row and include obj
        return [...prev, obj];
      }
    });
  };


  const updateLicenseDetails = (rows: any) => {
    const updatedDetails = licenseDetails?.map((item: any) => {
      const match = rows.find((row: any) => row.featureKey === item?.siteOrder?.data?.[0]?.featureKey);
      
      return {
        ...item,
        siteOrder: {
          ...item?.siteOrder,
          data: [
            {
              ...item?.siteOrder?.data?.[0],
              status: match?.status,
            },
          ],
        },
      };
    });
  
    setLicenseDetails(updatedDetails);
  };


  const handleToggleChange = async (row: any) => {
    // Prepare the payload to send to the API
    const obj = {
      "featureKey": row?.siteOrder?.data?.[0]?.featureKey,
      "status": row?.siteOrder?.data?.[0]?.status === 0 ? 1 : 0,
      "expiry": row?.siteOrder?.data?.[0]?.expiry
    }

    const payload = {
      orderId: siteOrderId? siteOrderId : order?.vSiteOrder?.orderId, // Replace with actual orderId if needed
      data: [obj], // Single row update
    };

    // Send the API request to enable the license
    const response = await putMethod("customer/order", payload);
    if (response?.status === 200) {
      setToast(response?.data?.message, "success");

      //If the checkbox is checked then uncheck it 
      if(row?.siteOrder?.data?.[0]?.status === 1) {
        setSelectedRows((prev: any) => {
            return prev.filter(
              (selectedRow: any) => selectedRow?.featureKey !== row?.siteOrder?.data?.[0]?.featureKey
            );
        });
      }
      //Local update
      updateLicenseDetails(response?.data?.result[0]?.data);
    } else {
      setToast(response?.data?.message, "error");
    }
  };


  const isRowSelected = (featureKey: any) =>
    selectedRows.some((selectedRow: any) => selectedRow?.featureKey === featureKey);


  useEffect(() => {
    setStartDate(getDate(0));
    setEndDate(getDate(1));
    fetchOrderDetail();
  }, []);

  const fetchOrderDetail = async () => {
    // const response = await getMethod(`customer/order/details/${order.vSiteOrder.orderId}`)     
    let response;
    if (siteOrderId)
      response = await getMethod("customer/order/details/" + siteOrderId);
    else
      response = await getMethod("customer/order/details/" + order?.vSiteOrder?.orderId);    
    if (response?.status === 200) {
      setLicenseDetails(response?.data?.result);
    } else {
      setToast(response?.data?.message, "error");
    }
  }

  let user = getUserId()


  const handleDisable = async () => {
    if (!licenseDetails || selectedRows.length === 0) return;

    // Prepare the payload
    const payload = {
      orderId: siteOrderId? siteOrderId : order?.vSiteOrder?.orderId,
      data: selectedRows,
    };

    const respo: any = await putMethod("customer/order", payload);
    if (respo?.status === 200) {
      setToast(respo?.data?.message, "success");
      setSelectedRows([]);
      //Local update
      updateLicenseDetails(respo?.data?.result[0]?.data);
    } else {
      setToast(respo?.data?.message, "error");
    }
  };





  function convertTimestampToDate(timestamp: number): string {
    const formattedDate = new Date(timestamp).toLocaleString();
    return formattedDate.replace(',', '  |');
  }


  const handleOpenFeaturePopup = (action: string, row: any, index: number) => {
    if (action === "edit") {
      let start_date: Date | string = new Date(row.activationOn);
      let end_date: Date | string = new Date(row.expiry);
      start_date = start_date.toISOString().split("T")[0];
      end_date = end_date.toISOString().split("T")[0];
    }
    setFeatureModalOpen(true);
  }

  const handleValidityChange = (value: number, start_date: string, setFieldValue: any) => {
    setValidity(value);
    setFieldValue("validity", value);
    setFieldValue("licenseKey", '');
    // handleStartDateChange(value, start_date, setFieldValue);
    getFilteredFeatureList(value, featureList);
  }

  const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };


  const handleStartDateChange = (raw_validity: number, start_date: any, setFieldValue: any) => {
    if (start_date) {
      if (typeof start_date !== "string") {
        start_date = start_date.toISOString().split("T")[0];
      }
  
      setFieldValue("start_date", start_date);
      setStartDate(startDate);
      setEndMin(getDate(1, start_date))
      setDisplayDatePicker(false);
    } else {
      setFieldValue("start_date", "");
      setFieldValue("end_date", "");
    }
  };

  const handleEndDateChange = (raw_validity: number, end_date: any, setFieldValue: any) => {
    if (end_date) {
      if (typeof end_date !== "string") {
        end_date = end_date.toISOString().split("T")[0];
      }
      setFieldValue("end_date", end_date);
      setEndDate(end_date);
      setStartMax(getDate(-1, end_date))
      setDisplayDatePicker(false);
    } else {
      setFieldValue("start_date", "");
      setFieldValue("end_date", "");
    }
  };


  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };


  useEffect(() => {
    if(featureModalOpen){
      fetchFeatureList();
    }
  }, [featureModalOpen])



  const fetchFeatureList = async () => {
    // const partner_id = await getPartnetId();
    // setPartnerId(partner_id);
    let partnerInfo
    const sess_user_data = localStorage.getItem("sess_user");
    if (sess_user_data != null) {
      try {
          const sess_user = JSON.parse(sess_user_data);
          const extractedProfileId = sess_user?.userProfile;
          if (extractedProfileId) {
          const priority = extractedProfileId?.priority;
          if (priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 || priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2) {
              partnerInfo = extractedProfileId?.ownerId;
          } else if (priority == PROFILE_TYPE.SUPER_ADMIN || priority == PROFILE_TYPE.INTEGRATOR){
              partnerInfo = partnerId
          }
          } else {
              console.error("Priority id not found in userProfile");
          }
      } catch (error) {
          console.error("Error parsing session user data:", error);
      }
  }
    const resp = await getMethod(`partner/license/${partnerInfo}`);
    if (resp?.status === 200) {
      const feature_list = resp?.data?.result;
            setFeatureList(feature_list);        
            if (feature_list?.length > 0) {
                getFilteredFeatureList(validity, feature_list); 
            } else {
                setFilteredFeatureList(feature_list);
            }
        }
    }



  const getFilteredFeatureList = (validity: number, feature_list: any) => {
    const filteredData = feature_list.filter((item: any) => {
      const { expiryTime, activationTime } = item?.license?.data;
      const msPerDay = 1000 * 60 * 60 * 24;
      const diffInDays = Math.floor(Math.abs(expiryTime - activationTime) / msPerDay);

      const [min, max] = LICENSE_VALIDITY_RANGES[validity] || [];      
      return diffInDays >= min && diffInDays <= max;
    });
    setFilteredFeatureList(filteredData);
  }


  function dateToEpoch(dateString: any) {
    // Parse the date string and convert to epoch time in milliseconds
    return new Date(dateString).getTime();
  }


  const validationSchema = Yup.object({
    licenseKey: Yup.string().required("Feature is required!"),
    validity: Yup.string().required("Validity is required!"),
    start_date: Yup.date().required("Start Date is required!"),
    end_date: Yup.date().required("End Date is required!"),
    quantity: Yup.number().min(1, "Quantity must be at least 1.").required("Quantity is required!"),
  });


  const handleFeatureChange = (licenseKey: string, values: any,setFieldValue: any) => {
    if (licenseKey != "") {
      const feature: any = featureList.find((item: any) => item?.license?.key === licenseKey);
      if (feature) {
        const expiry = feature?.license?.data?.expiryTime;
        const expiryDate = new Date(expiry)
        setStartMin(getDate(0))
        setStartMax(getDate(-1, expiryDate))
        setEndMin(getDate(1))
        setEndMax(formatDate(expiryDate))
        setStartDate(getDate(0))
        setEndDate(formatDate(expiryDate))
        setFieldValue('start_date', getDate(0))
        setFieldValue('end_date', formatDate(expiryDate))
        const available = feature?.countData?.available;
        setAvailableFeature(available);
      }
    } else {
      setAvailableFeature(0);
    }
    setFieldValue("licenseKey", licenseKey);
    setFieldValue("quantity", 1)
  }



  const [selectedRow, setSelectedRow] = useState<any>();
  const [displayQuantityDeleteModal, setDisplayQuantityDeleteModal] = useState(false);
  const [maximumDeleteQuantity, setMaximumDeleteQuantity] = useState(0);
  const [minimumDeleteQuantity, setMinimumDeleteQuantity] = useState(1);
  const [selectedDeletedQuantity, setSelectedDeletedQuantity] = useState(0);
  const [quantityDeleteErrMsg, setQuantityDeleteErrMsg] = useState("");
  const [enableDeleteButton, setEnableDeleteButton] = useState(false);



  const handleDeleteQuantity = (data: any) => {
    setSelectedRow(data);
    /* var max = 0;
    if(data?.countData?.assigned > 0) {
      max = data?.countData?.available;
    } else if(data?.countData?.assigned === 0 && data?.countData?.available > 1) {
      max = data?.countData?.available - 1;
    } else {
      max = 0;
    } */
    var max = data?.countData?.available;

    setMaximumDeleteQuantity(max);
    if(max === 0) {
      setMinimumDeleteQuantity(0);
    }
    setDisplayQuantityDeleteModal(true);
  }



  const handleDisplayQuantityDeleteModal = () => {
    setSelectedDeletedQuantity(0);
    setMaximumDeleteQuantity(0); 
    setMinimumDeleteQuantity(1); 
    setDisplayQuantityDeleteModal(false);
  }

  const handleDeleteQuantityChange = async (quantity: number) => {
    if(quantity > maximumDeleteQuantity) {
      setQuantityDeleteErrMsg(`You can delete maximum ${maximumDeleteQuantity} quantity!`);
      setEnableDeleteButton(false);
      return;
    }

    if(quantity < minimumDeleteQuantity) {
      setQuantityDeleteErrMsg(`You can delete minimum ${minimumDeleteQuantity} quantity!`);
      setEnableDeleteButton(false);
      return;
    }

    if(isNaN(quantity)) {
      setQuantityDeleteErrMsg("");
      setEnableDeleteButton(false);
      return;
    }

    if(quantity >= minimumDeleteQuantity && quantity <= maximumDeleteQuantity) {
      setQuantityDeleteErrMsg("");
    }

    setSelectedDeletedQuantity(quantity);
    setEnableDeleteButton(true);
  }


  
  const releaseOrderFeatureQuantity = async (orderId: string, featureKey: string, releasedQuantity: number) => {  
    setDisplayQuantityDeleteModal(false);  
    const payload = {
      "featureKey": featureKey,
      "quantity": releasedQuantity,                                           
    }
    
    const resp = await postMethod(`customer/order/releasefeature/${orderId}`, payload);    
    if(resp?.data?.code === 200) {
      ///setLicenseDetails(resp?.data?.result?.[0]?.data);
      fetchOrderDetail();
      setToast("Feature quantity deleted successfully!", "success");
    } else {
      setToast("Failed to delete the feature quantity!", "error");
    }
  }

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (datepickerRef.current && !datepickerRef.current.contains(event.target as Node)) {
        setDisplayDatePicker(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (endDatepickerRef.current && !endDatepickerRef.current.contains(event.target as Node)) {
        setDisplayEndDatePicker(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <ToastContainer />

      <div style={{
        display: "flex",
        alignContent: "space-between",
        justifyContent: "space-between",
        padding: "0 15px"
      }}>


        <Button onClick={() => handleOpenFeaturePopup('new', null, 0)} variant="contained" sx={{ color: '#1F2F34', height: '41px', borderColor: '#17B2EB', background: '#17B2EB', borderRadius: '30px', fontSize: '14px', fontWidth: '500', textTransform: 'unset', }}>
          Add Feature
        </Button>
        {selectedRows.length > 0 && <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap="4px"
          fontSize={"14px"}
          style={{
            padding: "8px 12px",
            cursor: "pointer",
            color: "#17B2EB",
          }}
          onClick={handleDisable}
        >
          <img src={disableIcon} alt="delete Icon" />
          Disable License
        </Stack>}

      </div>

      <TableContainer
        component={Paper}
        sx={{ backgroundColor: "#03171f", padding: "1rem" }}
      >
        <Table sx={{ backgroundColor: "#03171f", border: "1px solid #313838" }}>
          {/* Table Header */}
          <TableHead>
            <TableRow style={{ borderBottom: "2px solid #313838" }}>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              />
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                License Key / User
              </TableCell>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                License Type
              </TableCell>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Feature
              </TableCell>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Quantity
              </TableCell>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Status
              </TableCell>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Expiry Date
              </TableCell>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Delete
              </TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
            {licenseDetails && licenseDetails.length > 0 ? (
              licenseDetails?.map((row: any, index: number) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: isRowSelected(index)
                      ? "#1a2a2f"
                      : "inherit",
                    cursor: "pointer",
                  }}
                >
                  {/* Checkbox Column */}
                  <TableCell
                    sx={{
                      color: "#B4B7B8",
                      borderColor: "#313838",
                      width: "50px",
                    }}
                  >
                    <Checkbox
                      disabled={row?.siteOrder?.data?.[0]?.status !== 1}
                      checked={isRowSelected(row?.siteOrder?.data?.[0]?.featureKey)}
                      onChange={() => handleCheckboxChange(row)}
                      sx={{ color: "#B4B7B8" }}
                    />
                  </TableCell>
                  {/* Data Columns */}
                  <TableCell
                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                  >
                    {row?.siteOrder?.data?.[0]?.licenseKey}
                  </TableCell>
                  
                  <TableCell
                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                  >
                    {(row?.siteOrder?.data?.[0]?.validity === 1 || row?.siteOrder?.data?.[0]?.validity === 3 || row?.siteOrder?.data?.[0]?.validity === 5) ? `${row?.siteOrder?.data?.[0]?.validity} Year${row?.siteOrder?.data?.[0]?.validity > 1 ? 's' : ''}` : (
                      row?.siteOrder?.data?.[0]?.validity === 30 ? "30 Days" : (
                        row?.siteOrder?.data?.[0]?.validity === 365 ? "1 Year" : (
                          row?.siteOrder?.data?.[0]?.validity / 365 + " Years")
                      )
                    )}
                  </TableCell>
                  <TableCell
                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                  >
                    {row?.siteOrder?.data?.[0]?.featureName}
                  </TableCell>
                  <TableCell
                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                  >
                     {row?.countData?.assigned}/{row?.countData?.total}
                  </TableCell>
                  <TableCell
                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                  >
                    {/* <Switch
                    disabled={row.status !== 0}
                    checked={row.status}
                    onChange={() => handleToggleChange(row)}
                    color="primary"
                    sx={{
                      "& .MuiSwitch-thumb": { color: "#B4B7B8" },
                      "& .MuiSwitch-track": { backgroundColor: "#313838" },
                    }}
                  /> */}
                    {/* {row.status} */}
                    <AntSwitch
                      // disabled={row.status !== 0}
                      checked={row?.siteOrder?.data?.[0]?.status}
                      onChange={() => handleToggleChange(row)}
                      inputProps={{ "aria-label": "ant design" }}
                    />

                  </TableCell>
                  <TableCell
                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                  >
                    {convertTimestampToDate(row?.siteOrder?.data?.[0]?.expiry)}
                  </TableCell>
                  <TableCell
                    sx={{ color: "#17b2eb", borderColor: "#313838" }}
                  >
                    {/* {((row?.countData?.assigned > 0 && row?.countData?.available > 0) || (row?.countData?.available > 1)) ? ( */}
                    {row?.countData?.available > 0 ? (
                      <span onClick={(e) => {
                        setEnableDeleteButton(false);
                        setSelectedDeletedQuantity(0);
                        setMaximumDeleteQuantity(0); 
                        setMinimumDeleteQuantity(1); 
                        handleDeleteQuantity(row);
                        }}
                      >
                        <img src={deleteIcon} alt="delete Icon" /> Delete
                      </span>
                    ) : (
                      <span style={{color: "#b1b4b5"}}>
                        <img src={'/icons/delete-icon-grey.svg'} alt="delete Icon" width={13} height={13} /> Delete
                      </span>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
                <TableRow sx={{ background: '#192529' }}>
                  <TableCell
                    sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', textAlign: 'center' }}
                    colSpan={9}
                  >
                    {loader ? (
                      <CircularProgress color="primary" />
                    ) : (
                      "No Data!"
                    )}
                  </TableCell>
                </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>


      <Modal open={featureModalOpen} onClose={() => setFeatureModalOpen(false)} className="AddFeatureM">
        <Box sx={{
          maxWidth: '736px',
          width: '100%',
          margin: '64px auto 0',
          padding: '24px',
          borderRadius: '30px',
          borderColor: '#5A5F60 !important',
          border: '1px solid',

        }}
        >
          <Typography variant="h6" component="h2" gutterBottom
            sx={{
              fontSize: '20px',
              color: '#E2E3E3',
              borderBottom: '1px solid #5A5F60',
              paddingBottom: '10px',
              marginBottom: '30px',
            }}
          >
            {"Add a Feature"}
            <CloseIcon style={{ float: "right", cursor: "pointer" }} onClick={() => setFeatureModalOpen(false)} />
          </Typography>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnBlur={true} // Ensures validation happens on blur
            validateOnChange={true} // Ensures validation updates on change
            onSubmit={async (values, { setSubmitting }) => {
              console.log("Form Submitted:", values);

              let partnerInfo
              const sess_user_data = localStorage.getItem("sess_user");
              if (sess_user_data != null) {
                  try {
                      const sess_user = JSON.parse(sess_user_data);
                      const extractedProfileId = sess_user?.userProfile;
                      if (extractedProfileId) {
                      const priority = extractedProfileId?.priority;
                      if (priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 || priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2) {
                          partnerInfo = extractedProfileId?.ownerId;
                      } else if (priority == PROFILE_TYPE.SUPER_ADMIN || priority == PROFILE_TYPE.INTEGRATOR){
                          partnerInfo = partnerId
                      }
                      } else {
                          console.error("Priority id not found in userProfile");
                      }
                  } catch (error) {
                      console.error("Error parsing session user data:", error);
                  }
              }

              const feature: any = featureList.find((item: any) => item?.license?.key === values.licenseKey);
              const productId = feature?.license?.data?.productId;
              const analyticType = feature?.license?.data?.analyticType;

              let payload = {
                "orderId": order?.vSiteOrder?.orderId ?? siteOrderId,
                "partnerId": partnerInfo,
                "data": [
                  {
                    "licenseKey": values.licenseKey,
                    "quantity": values.quantity,
                    "validity": values.validity,
                    "activationOn": dateToEpoch(values.start_date),
                    "expiry": dateToEpoch(values.end_date),
                    "featureName": feature.license?.data?.name,
                    "licenseType": feature?.license?.data?.licenseType,
                  } as Record<string, any>
                ]
              }
              if (productId) {
                payload.data[0].productId = productId;
              }

              if (analyticType !== 0) {
                payload.data[0].analyticType = analyticType;
              }
              const response = await postMethod("customer/order/addfeature", payload);
              if (response?.status === 200) {
                //setLicenseDetails(response?.data?.result[0]?.data);
                fetchOrderDetail();
                setToast(response?.data?.message, "success");
                setFeatureModalOpen(false);
              } else {
                setToast(response?.data?.message, "error");
              }



            }}
          >
            {({ values, isSubmitting, setFieldValue, setFieldTouched }) => (
              <Form>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="subtitle1"
                        sx={{
                          color: '#B4B7B8',
                          fontSize: '16px',
                          marginBottom: '10px',
                        }}
                      >
                        Feature Information
                      </Typography>

                      <RBFORM.Group>
                        <Typography variant="subtitle1"
                          sx={{
                            color: '#B4B7B8',
                            fontSize: '16px',
                            marginBottom: '2px',
                          }}
                        >
                          Feature
                        </Typography>
                        <Field
                          name="licenseKey"
                          as="select"
                          className="inputC custDropdown"
                          onChange={(e: any) => handleFeatureChange(e.target.value, values, setFieldValue)}
                        >
                          <option value=''>Select Feature</option>
                          {filteredFeatureList.length > 0 &&
                            filteredFeatureList.map((feature: any, index: number) => (
                              <option key={feature?.license?.key} value={feature?.license?.key}>{feature?.license?.data?.name}</option>
                            ))
                          }
                        </Field>
                        <ErrorMessage name="licenseKey">
                          {(msg) => <Typography sx={{ color: "#f44336", fontSize: "11px", marginTop: "-15px" }}>{msg}</Typography>}
                        </ErrorMessage>
                      </RBFORM.Group>
                    </Box>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography variant="h6"
                      sx={{
                        fontSize: '16px',
                        color: '#B4B7B8',
                        fontWeight: '400',
                      }}
                    >
                      <Typography variant="subtitle1"
                        sx={{
                          color: '#B4B7B8',
                          fontSize: '16px',
                          marginBottom: '10px',
                        }}
                      > License Type</Typography>
                    </Typography>
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="subtitle1"
                        sx={{
                          color: '#B4B7B8',
                          fontSize: '14px',
                          marginBottom: '5px',
                        }}
                      > Valid from Activation
                      </Typography>
                      <RadioGroup
                        name="validity"
                        row
                        value={validity}
                        onChange={(e) => handleValidityChange(parseInt(e.target.value), values.start_date, setFieldValue)}
                        style={{ borderRadius: "30px", backgroundColor: "#293236" }}
                      >
                        <FormControlLabel value={30} control={<Radio />} label="30 Days" />
                        <FormControlLabel value={365} control={<Radio />} label="1 Year" />
                        <FormControlLabel value={1095} control={<Radio />} label="3 Years" />
                        <FormControlLabel value={1825} control={<Radio />} label="5 Years" />
                      </RadioGroup>
                    </Box>
                  </Grid>
                </Grid>

                <Box
                  sx={{
                    display: 'flex',
                    marginBottom: '10px',
                  }}

                >
                  <Typography variant="subtitle1"
                    sx={{
                      color: '#B4B7B8',
                      fontSize: '16px',
                      fontWeight: '500',
                    }}
                    className="tagR"
                  >License Usage</Typography>

                </Box>

                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <RBFORM.Group>
                      <Typography variant="subtitle1"
                        sx={{
                          color: '#B4B7B8',
                          fontSize: '16px',
                          marginBottom: '2px',
                        }}
                      > Starts</Typography>
                      <Field
                        name="start_date"
                        as="input"
                        type="date"
                        component={TextField}
                        className="inputC inputCalendar"
                        inputProps={{
                          min: getTodayDate(),
                          readOnly: true,
                        }}
                        onClick={(e: any)=>{setStartDate(values.start_date); setDisplayDatePicker(true);}}
                      />

                      {displayDatePicker &&
                        <div ref={datepickerRef} style={{ position: "absolute", marginTop: "-60px", marginLeft:"90px", zIndex: 9999 }}>
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => handleStartDateChange(validity, date, setFieldValue)}
                          minDate={startMin}
                          maxDate={startMax}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          inline
                          id="custom-date-picker"
                        />
                        </div>
                      }

                    </RBFORM.Group>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <RBFORM.Group>
                      <Typography variant="subtitle1"
                        sx={{
                          color: '#B4B7B8',
                          fontSize: '16px',
                          marginBottom: '2px',
                        }}
                      > Ends</Typography>
                      <Field
                        name="end_date"
                        type="date"
                        component={TextField}
                        className="inputC inputCalendar"
                        inputProps={{
                          min: getTodayDate(),
                          readOnly: true,
                        }}
                        onClick={(e: any)=>{setEndDate(values.end_date); setDisplayEndDatePicker(true);}}
                      />

                      {displayEndDatePicker &&
                        <div ref={endDatepickerRef} style={{ position: "absolute", marginTop: "-60px", marginLeft:"90px", zIndex: 9999 }}>
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => handleEndDateChange(validity, date, setFieldValue)}
                          minDate={endMin}
                          maxDate={endMax}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          inline
                          id="custom-end-date-picker"
                        />
                        </div>
                      }
                    </RBFORM.Group>
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    display: 'flex',
                    marginBottom: '10px',
                  }}
                >
                  <Typography variant="subtitle1"
                    sx={{
                      color: '#B4B7B8',
                      fontSize: '16px',
                      fontWeight: '500',
                    }}
                    className="tagR"
                  >License Options</Typography>
                </Box>

                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <RBFORM.Group>
                      <Typography variant="subtitle1"
                        sx={{
                          color: '#B4B7B8',
                          fontSize: '16px',
                          marginBottom: '2px',
                        }}
                      >   Quantity {availableFeature > 0 &&
                        <span style={{ float: "right", fontSize: "12px", marginTop: "5px", marginRight: "10px" }}>
                          <img src={"/info.png"} style={{ display: "block", float: "left", marginTop: "2px" }}></img>&nbsp;
                          Available - {availableFeature}
                        </span>}
                      </Typography>
                      <button
                        disabled={values.licenseKey ? false : true}
                        type="button"
                        onClick={(e: any) => {
                          // Ensure invalid values like -5 are reset
                          const value = values.quantity;
                          if (value >= 1 && value <= availableFeature) {
                            setFieldValue('quantity', Math.max(values.quantity - 1, 1));
                          } else if (value < 1) {
                            setFieldValue('quantity', 1); // Reset to minimum
                          } else if (value > availableFeature) {
                            setFieldValue('quantity', availableFeature); // Reset to maximum
                          }
                        }}
                        style={{
                          background: 'transparent',
                          color: '#E2E3E3',
                          cursor: 'pointer',
                          outline: 'none',
                          border: '1px solid #313838',
                          padding: '0px 15px',
                          height: '40px',
                          borderRadius: '5px 0px 0px 5px',
                        }}
                        className="incr-dcr-btn"
                      >
                        -
                      </button>
                      <Field
                        name="quantity"
                        type="number"
                        style={{
                          width: "75%",
                          height: "40px",
                          textAlign: "center",
                          borderRadius: '0px',
                        }}
                        className="inputC"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          // Ensure invalid values like -5 are reset
                          const value = parseInt(e.target.value, 10);
                          if (value >= 1 && value <= availableFeature) {
                            setFieldValue('quantity', value);
                          } else if (value < 1) {
                            setFieldValue('quantity', 1); // Reset to minimum
                          } else if (value > availableFeature) {
                            setFieldValue('quantity', availableFeature); // Reset to maximum
                          }
                        }}
                      />
                      <button
                        disabled={values.licenseKey ? false : true}
                        type="button"
                        onClick={(e: any) => {
                          // Ensure invalid values like -5 are reset
                          const value = values.quantity;
                          if (value >= 1 && value <= availableFeature) {
                            setFieldValue('quantity', Math.min(values.quantity + 1, availableFeature));
                          } else if (value < 1) {
                            setFieldValue('quantity', 1); // Reset to minimum
                          } else if (value > availableFeature) {
                            setFieldValue('quantity', availableFeature); // Reset to maximum
                          }
                        }}
                        style={{
                          background: 'transparent',
                          color: '#E2E3E3',
                          cursor: 'pointer',
                          outline: 'none',
                          border: '1px solid #313838',
                          padding: '0px 15px',
                          height: '40px',
                          borderRadius: '0px 5px 5px 0px',
                        }}
                        className="incr-dcr-btn"
                      >
                        +
                      </button>
                    </RBFORM.Group>
                  </Grid>

                  <Field
                    name="siteId"
                    type="hidden"
                    component={TextField}
                    className="inputC"
                    value={siteId}
                    style={{ display: "none" }}
                  />

                  <Field
                    name="partnerId"
                    type="hidden"
                    component={TextField}
                    className="inputC"
                    value={partnerId}
                    style={{ display: "none" }}
                  />
                </Grid>

                {/* {JSON.stringify(values, null, 2)} */}



                <Box sx={{ display: "flex", borderTop: "1px solid #5A5F60", paddingTop: '20px', justifyContent: "flex-end", gap: 2 }}>
                  <Button onClick={() => setFeatureModalOpen(false)} variant="outlined"
                    sx={{ color: '#0699CE', textTransform: 'capitalize', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}
                    className='hoverBtn'
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting}
                    sx={{
                      color: '#1F2F34', height: '41px', lineHeight: '41px',
                      borderColor: '#0B4A62', background: '#17B2EB',
                      borderRadius: '25px', fontSize: '14px',
                      fontWidth: '500',
                      textTransform: 'capitalize',
                    }}
                  >
                    Confirm
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Modal>



      <Modal
        open={displayQuantityDeleteModal}
        onClose={handleDisplayQuantityDeleteModal}
        closeAfterTransition
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={displayQuantityDeleteModal}>
          <Box sx={styleModal}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" style={{borderBottom: "1px solid #313838", paddingBottom:"15px"}}>
              <Typography sx={{ color: '#E2E3E3', fontWeight: 500, fontSize: '20px' }}>
                Delete Licenses
              </Typography>
              <img src={closeIcon} alt="close icon" onClick={handleDisplayQuantityDeleteModal} style={{ cursor: 'pointer' }} />
            </Stack>
            
            <Box sx={{ paddingTop: "20px", color: "#B4B7B8" }}>
              <Typography>All the site / device associated with this license will be affected.</Typography>
            </Box>
            <Box sx={{ paddingTop: "20px", color: "#B4B7B8" }}>
              <Typography>Enter the number of licenses to be deleted.</Typography>
            </Box>

            <Box sx={{ paddingTop: "20px" }}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 6, md: 6 }}>
                  <Typography>Available to Delete</Typography>
                  <MUITextField
                    disabled={true}
                    sx={{
                      backgroundColor: "#5A5F60",
                      "& .MuiInputBase-input.Mui-disabled": {
                        color: "#B4B7B8", // Text color for disabled state
                        WebkitTextFillColor: "#B4B7B8", // Ensures color works properly in WebKit browsers
                      },
                      "& .MuiOutlinedInput-root.Mui-disabled": {
                        backgroundColor: "#5A5F60",
                        border: "0px solid #313838",
                      },
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      height: "40px",
                      paddingTop: "0",
                      paddingBottom: "0",
                      fontSize: "14px",
                      fontWeight: "400",
                      borderRadius: "8px",
                    }}
                    className="deleteFeatureQantity"
                    type="number"
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    }}
                    value={maximumDeleteQuantity}
                  />

                </Grid>

                <Grid size={{ xs: 6, md: 6 }}>
                  <Typography>Delete Quantity</Typography>
                  <MUITextField
                    autoFocus
                    inputRef={inputRef}
                    onChange={(e) => handleDeleteQuantityChange(parseInt(e.target.value))}
                    style={{
                      backgroundColor: "#192529",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      height: "40px",
                      paddingTop: "0",
                      paddingBottom: "0",
                      color: "#fff",
                      fontSize: "14px",
                      fontWeight: "400",
                      border: "1px solid #313838",
                      borderRadius: "8px",
                      padding: "0px",
                    }}
                    className="deleteFeatureQantity"
                    type="number"
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    }}
                    defaultValue={0}
                  />
                </Grid>
              </Grid>
            </Box>
            {quantityDeleteErrMsg && <span style={{color: "red", display: "block", width: "100%", fontWeight: "500"}}>{quantityDeleteErrMsg}</span>}
            
            <Box sx={{ paddingTop: "20px", color: "#B4B7B8" }}>
              <Typography>Are you sure you want to delete license for this site / device?</Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'end', gap: '12px', marginTop: "20px" }}>
              <Box
                sx={{ minWidth: 70, textAlign: 'center', cursor: 'pointer', color: '#17B2EB', fontSize: '14px', fontWeight: 500, border: '1px solid #0B4A62', padding: '12px', borderRadius: '30px' }}
                onClick={handleDisplayQuantityDeleteModal}
                className="hoverBtn"
              >
                Cancel
              </Box>
              {enableDeleteButton ? (<Box
                sx={{ minWidth: 70, textAlign: 'center', backgroundColor: '#17B2EB', padding: '12px', borderRadius: '30px', cursor: 'pointer', color: '#1E2121', fontSize: '14px', fontWeight: 500, margin: '0' }}
                onClick={(e)=>releaseOrderFeatureQuantity(selectedRow?.siteOrder?.orderId, selectedRow?.siteOrder?.data?.[0]?.featureKey, selectedDeletedQuantity)}
              >
                Delete
              </Box>
              ) : (
                <Box
                  sx={{ minWidth: 70, textAlign: 'center', backgroundColor: '#3D484D', padding: '12px', borderRadius: '30px', cursor: 'not-allowed', color: '#1E2121', fontSize: '14px', fontWeight: 500, margin: '0' }}
              >
                Delete
              </Box>
              )}
            </Box>
          </Box>
        </Fade>
      </Modal>
      


      <Modal
        open={false}
        onClose={handleDisplayQuantityDeleteModal}
        aria-labelledby="edit-site-modal"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(4px)", // For backdrop blur effect
        }}
      >
        <Box
          sx={{
            backgroundColor: "#262626",
            borderRadius: 2,
            padding: 4,
            width: "400px",
            boxShadow: 24,
          }}
          style={{padding: "15px"}}
        >
          {/* Header */}
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }} style={{borderBottom: "1px solid #ccc"}}>
            <Typography variant="h6" id="edit-site-modal">
              Delete Available Quantity
            </Typography>
            <CloseIcon style={{ float: "right", cursor: "pointer" }} onClick={handleDisplayQuantityDeleteModal} />
          </Box>

          {/* Form */}
          <Grid container spacing={2}>
            {/* Site Name and Email */}
            <Grid size={{ xs: 12, md: 12 }} style={{marginBottom: "-20px"}}>
              Available Quantity to Delete : {maximumDeleteQuantity}
            </Grid>
            <Grid size={{ xs: 12, md: 12 }} style={{display: "flex"}}>
              <div style={{float: "left", width: "50%", display: "flex", alignItems: "center"}}>Delete Quantity : </div>
              <MUITextField
                inputRef={inputRef}
                variant="outlined"
                fullWidth
                onChange={(e)=>handleDeleteQuantityChange(parseInt(e.target.value))}
                margin="normal"
                style={{width: "50%", backgroundColor: "#fff"}}
                className="deleteFeatureQantity"
                type="number"
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
              />
            </Grid>
            {quantityDeleteErrMsg && <span style={{color: "red", display: "block", marginTop: "-10px", width: "100%", fontWeight: "500"}}>{quantityDeleteErrMsg}</span>}
          </Grid>

          {/* Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 3,
            }}
          >
            <Button variant="outlined" onClick={handleDisplayQuantityDeleteModal}>
              Cancel
            </Button>
            <Button
              disabled={!enableDeleteButton}
              variant="contained"
              color="primary"
              type="button"
              sx={{
                bgcolor: enableDeleteButton ? "primary.main" : "#565353", // Background color
                color: enableDeleteButton ? "white" : "lightgray", // Font color
                "&.Mui-disabled": {
                  bgcolor: "#565353", // Disabled background
                  color: "darkgray", // Disabled font color
                },
              }}
              onClick={(e)=>releaseOrderFeatureQuantity(selectedRow?.siteOrder?.orderId, selectedRow?.siteOrder?.data?.[0]?.featureKey, selectedDeletedQuantity)}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default OrderDetailTabThree